export enum Inheritance {
  NOT_INHERITED = 0,
  INHERITED = 2
}
